import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { previewDataAccessAssignment } from '../services'
import type { ResponseObject } from '@/types/shared'
import type { DataAccessPreviewResponse } from '../types'

export const useDataAccessPreview = (id: number, employeeId: number | null) =>
    useQueryWithHandler<ResponseObject<DataAccessPreviewResponse>>(
        {
            queryKey: [
                QUERY_KEYS.DATA_ACCESS_ASSIGNMENTS,
                'preview',
                id,
                employeeId,
            ],
            queryFn: () => previewDataAccessAssignment(id, employeeId!),
            enabled: !!employeeId && !!id,
            staleTime: 0,
        },
        { showLoading: false }
    )
